import React from 'react';
import Tiles from './tiles';
import CommonUtils from '../util/CommonUtils';

function VideosHome() {

    const header = { label: "Videos", description: "These are some helpful videos that give you an overview of your site." };
    const label = <span className="cursor-pointer text-primary">View <i className="fa fa-angle-right"></i></span>;

    const reports = [{
        name: 'Time-lapse Video',
        description: 'View, generate and / or schedule time-lapse videos.',
        pic: <i className="fa fa-video text-danger"></i>,
        report: <a href="/videos/timelapse-video">{label}</a>
    }];

    if (CommonUtils.hasPermission('SITESUPT-UI-VIDEO-LIBRARY')) {
        reports.push({
            name: "Video Library",
            description: 'View video library of time-lapse and recorded live videos.',
            pic: <i className="fa fa-photo-video text-success"></i>,
            report: <a href="/videos/video-library">{label}</a>
        });
    }

    if (CommonUtils.hasPermission('SITESUPT-UI-VIDEO-HISTORICAL')) {
        reports.push({
            name: "Historical Videos",
            description: 'View historical videos generated by you.',
            pic: <i className="fa fa-photo-video text-success"></i>,
            report: <a href="/videos/historical-videos">{label}</a>
        });
    }

    return (
        <React.Fragment>
            <div className="page-container">
                <Tiles header={header} reports={reports}></Tiles>
            </div>
        </React.Fragment >
    );
}

export default VideosHome;